export enum EntityTypeDynamic {
    NONE = 'none',
    EVALUATION = '$common_evaluation',
    SURVEY = '$common_survey',
}
